import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "form-completion-panel",
  "data-testid": "form-completion-panel"
}
const _hoisted_2 = {
  "data-testid": "form-completion-panel-title",
  class: "text-xs font-semibold text-black-lp-300 mb-3"
}
const _hoisted_3 = { class: "flex items-start w-full relative" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "absolute left-6 right-6 top-3 z-0 h-0.5 text-gray-lp-500",
  style: {"background":"repeating-linear-gradient(to right, currentColor 0 8px, transparent 8px 16px)"}
}, null, -1)
const _hoisted_5 = { class: "relative z-10 flex w-fit flex-col items-center gap-2 cursor-pointer" }
const _hoisted_6 = {
  key: 0,
  class: "w-6 h-6 rounded-full bg-green-lp-400 flex items-center justify-center flex-shrink-0"
}
const _hoisted_7 = {
  key: 1,
  viewBox: "0 0 16 16",
  fill: "currentColor",
  class: "w-6 h-6 flex-shrink-0 text-red-lp-1200"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566ZM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5Zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" }, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "w-6 h-6 z-10 bg-white rounded-full border-2 border-gray-lp-800 flex items-center justify-center text-10px font-bold leading-none text-black-lp-100 flex-shrink-0"
}
const _hoisted_10 = {
  key: 0,
  class: "relative mt-3 rounded-lg bg-gray-lp-1400 border border-gray-lp-1600 p-3 grid grid-cols-3 gap-x-3 gap-y-1.5"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", {
  class: "absolute -top-1 w-4 h-4 bg-gray-lp-1400 border border-gray-lp-1600 transform rotate-45",
  style: {"right":"28px"}
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "w-1 h-1 rounded-full bg-black-lp-300 flex-shrink-0" }, null, -1)
const _hoisted_13 = { class: "text-10px font-medium text-black-lp-100 truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.panelTitle), 1),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: item.key,
          "data-testid": `form-completion-item-${item.key}`,
          class: ["flex flex-1 min-w-0", 
            index === 0
              ? 'justify-start'
              : index === _ctx.items.length - 1
              ? 'justify-end'
              : 'justify-center'
          ],
          onClick: ($event: any) => (_ctx.onItemClick(item.key))
        }, [
          _createVNode("div", _hoisted_5, [
            (item.state === 'complete')
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_Icons, {
                    name: "check",
                    class: "w-2.5 h-2.5 text-white"
                  })
                ]))
              : (item.state === 'error')
                ? (_openBlock(), _createBlock("svg", _hoisted_7, [
                    _hoisted_8
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(index + 1), 1)),
            _createVNode("span", {
              "data-testid": `form-completion-item-label-${item.key}`,
              class: ["text-10px font-semibold text-center leading-tight w-16 break-words", _ctx.itemLabelColor(item.state)]
            }, _toDisplayString(item.label), 11, ["data-testid"])
          ])
        ], 10, ["data-testid", "onClick"]))
      }), 128))
    ]),
    (_ctx.documentFields.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentFields, (field) => {
            return (_openBlock(), _createBlock("div", {
              key: field.fieldKey,
              "data-testid": `form-completion-document-field-${field.fieldKey}`,
              class: "flex items-center gap-1 min-w-0"
            }, [
              _hoisted_12,
              _createVNode("span", _hoisted_13, _toDisplayString(field.fieldLabel), 1)
            ], 8, ["data-testid"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}